import { ReportFilter } from '../../types';

export const getFilterApplied = <T extends keyof ReportFilter>(
  filters: T[],
  key: T,
  value: unknown
): T[] => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return filters.filter(i => i !== key);
  }

  if (filters.includes(key)) {
    return filters;
  }

  return [...filters, key];
};
